<template>
    <div class="border-b border-theme-border">
        <div class="flex flex-wrap">
            <div class="md:w-1/4 w-4/12 flex justify-center items-center py-3">
                <button
                    class="w-28 h-28 p-0"
                    @click="goToMainPage(reference.slug)"
                >
                    <img
                        v-img:group
                        v-img-loading
                        class="w-full h-full"
                        :src="reference.images[0].url | image"
                        :alt="reference.images[0].alt"
                        loading="lazy"
                    />
                </button>
            </div>
            <div class="md:w-3/4 w-8/12 flex flex-col justify-around py-3 px-1">
                <div class="flex justify-between">
                    <router-link
                        :to="`/app/references/detail/${reference.productId}`"
                        class="btn-a p-0"
                    >
                        {{ reference.name }} / # {{ reference.id }}
                    </router-link>
                </div>

                <div class="flex flex-wrap">
                    <div class="w-5/12 flex md:flex-col justify-between mr-1">
                        <strong class="text-theme-primary">SKU </strong>
                        <div class="flex items-center">
                            <small>
                                {{ reference.sku }}
                            </small>
                        </div>
                    </div>
                    <div class="w-5/12 flex md:flex-col justify-between mr-1">
                        <strong class="text-theme-primary">
                            Precio de venta
                        </strong>
                        <small>
                            {{ reference.priceOffer | money }}
                        </small>
                    </div>
                    <div
                        v-if="
                            isOfferPrice(reference.price, reference.priceOffer)
                        "
                        class="w-5/12 flex md:flex-col justify-between mr-1"
                    >
                        <strong class="text-theme-primary">
                            Precio anterior
                        </strong>
                        <small>
                            {{ reference.price | money }}
                        </small>
                    </div>
                    <div class="w-5/12 flex md:flex-col justify-between mr-1">
                        <strong class="text-theme-primary">Color </strong>
                        <small class="capitalize">
                            {{ reference.color }}
                        </small>
                    </div>
                    <div class="w-5/12 flex md:flex-col justify-between mr-1">
                        <strong class="text-theme-primary">Tamaño </strong>
                        <small class="capitalize">
                            {{ reference.size }}
                        </small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { DEFAULT_IMAGE_URL } from "@/common/constants";
import { isOfferPrice } from "@/common/lib/price-offer";

export default {
    name: "ReferenceItem",
    props: {
        reference: {
            type: Object,
            required: true,
            default: () => ({
                productId: 1,
                id: 1,
                sku: "UEUM11",
                name: "Sudadera colegio montessori 2",
                slug: "sudadera-colegio-montessori-2",
                priceOffer: 150000,
                price: 150000,
                images: [
                    {
                        id: 1,
                        url: DEFAULT_IMAGE_URL,
                        alt: "Chaqueta de sudadera colegio montessori 2 kennedy Bogotá."
                    }
                ]
            })
        }
    },
    methods: {
        isOfferPrice,
        goToMainPage(slug) {
            window.open(`${slug}`, "_blank").focus();
        }
    }
};
</script>
